
export default {
  isAuthenticated: state => !!state.accessToken,
  accessToken: state => state.accessToken,
  tokenType: state => state.tokenType,
  getUser: state => state.user,
  isAdmin: state => state.isAdmin,
  isSuperAdmin: state => state.isSuperAdmin,
  isArtist: state => state.isArtist,
  isArtistInApproval: state => state.isArtist && !!state.user && state.user.status === 1,
  isOps: state => state.isOps,
  isFinance: state => state.isFinance,
  isRecruitment: state => state.isRecruitment,
  isReviewer: state => state.isReviewer,
  getName: state => state.user.name,
  isUpdateTnc: state => state.isUpdateTnc,
  getRole: state => state.roleList,
};



// WEBPACK FOOTER //
// ./src/stores/Auth/getters/index.js